import { computed, onMounted, onUnmounted, ref } from 'vue'

/**
 * 页面整体等比缩放（参考绝区零官网的全页缩放策略，2026-08-31 拍板）：
 * 以设计稿宽度为基准，缩放系数 = 视口宽 / designWidth——
 * 放大不设上限（内容比例恒定，怎么拉都撑不出屏幕），缩小到 minScale 兜底，
 * 低于下限后停止缩小、由页面 min-width 出横向滚动。
 *
 * 用 CSS zoom 而非 transform:scale：zoom 参与布局（页面高度/滚动条自然正确），
 * 本产品只跑 Chrome/Edge（Web Serial 前提），zoom 兼容性无虞。
 */
export function usePageZoom(designWidth = 1440, minScale = 0.75) {
  const zoom = ref(1)

  const sync = () => {
    zoom.value = Math.max(minScale, window.innerWidth / designWidth)
  }

  onMounted(() => {
    sync()
    window.addEventListener('resize', sync)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', sync)
  })

  /** 根节点样式：zoom 本身 + 视觉满高（100vh 是布局像素，需除回 zoom）；
      同时把系数写进 --page-zoom，供子页面做 vh 修正（vw/vh 不吃 zoom） */
  const rootStyle = computed(() => ({
    zoom: String(zoom.value),
    minHeight: `calc(100vh / ${zoom.value})`,
    '--page-zoom': String(zoom.value),
  }))

  return { zoom, rootStyle }
}
